import * as React from 'react';
import { useLocalization } from '@fluent/react';
import { useNavigate } from 'react-router-dom';

import DisclosurePanel from './DisclosurePanel';
import StaticPageLayout from '#/layouts/StaticPageLayout';
import faqBgImg from '#/assets/static-page/faq_main_bg.png';
import { PublicRoute } from '#/constants/page-route';

const FaqPage = () => {
  const { l10n } = useLocalization();
  const navigate = useNavigate();
  const emailAddress = import.meta.env.VITE_COMPANY_CUSTOMER_SERVICE_ADDRESS;

  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <StaticPageLayout>
      <div className="w-full">
        <div>
          <img src={faqBgImg} className="object-cover w-full h-1/4" />
        </div>
        <div className="flex px-16 py-20 gap-x-32">
          <div className="flex flex-col divide-y divide-gray-400 w-72">
            <div className="flex flex-col mb-10 text-lg gap-y-3">
              <div className="text-black">General</div>
              <div className="text-gray-400">Orders</div>
              <div className="text-gray-400">Contact Us</div>
              <div className="text-gray-400">Shipper</div>
              <div className="text-gray-400">Transporter</div>
            </div>
            <div className="">
              <p className="mt-10">
                Everything you need to know about MOVE. Can’t find the answer your are looking for?
                Please contact us via email to{' '}
                <a href={`mailto:${emailAddress}`} className="underline">
                  {emailAddress}
                </a>{' '}
                We’ll be glad to help.
              </p>
              <button
                className="flex content-center w-full px-5 py-4 mt-10 bg-blue-700 rounded-full hover:cursor-pointer"
                onClick={() => navigate(PublicRoute.ContactUs)}
              >
                <div className="mx-auto text-white">{l10n.getString('contact-us')}</div>
              </button>
            </div>
          </div>
          <div className="flex flex-col w-full gap-y-20">
            <div>
              <div className="text-3xl text-black mb-14">General</div>
              <DisclosurePanel
                description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                    incididunt? Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                    eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
                    veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
                    consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
                    dolore eu fugiat nulla pariatur."
                title="What is MOVE?"
              />
              <DisclosurePanel
                description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                    incididunt? Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                    eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
                    veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
                    consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
                    dolore eu fugiat nulla pariatur."
                title="How much does it cost to join MOVE?"
              />
              <DisclosurePanel
                description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                    incididunt? Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                    eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
                    veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
                    consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
                    dolore eu fugiat nulla pariatur."
                title="What type of trucks does MOVE accept?"
              />
              <DisclosurePanel
                description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                    incididunt? Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                    eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
                    veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
                    consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
                    dolore eu fugiat nulla pariatur."
                title="I have trucks, how can I make money on MOVE?"
              />
            </div>
            <div>
              <div className="text-3xl text-black mb-14">Orders</div>
              <DisclosurePanel
                description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                    incididunt? Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                    eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
                    veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
                    consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
                    dolore eu fugiat nulla pariatur."
                title="What is MOVE?"
              />
              <DisclosurePanel
                description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                    incididunt? Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                    eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
                    veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
                    consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
                    dolore eu fugiat nulla pariatur."
                title="How much does it cost to join MOVE?"
              />
              <DisclosurePanel
                description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                    incididunt? Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                    eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
                    veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
                    consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
                    dolore eu fugiat nulla pariatur."
                title="What type of trucks does MOVE accept?"
              />
              <DisclosurePanel
                description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                    incididunt? Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                    eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
                    veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
                    consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum
                    dolore eu fugiat nulla pariatur."
                title="I have trucks, how can I make money on MOVE?"
              />
            </div>
          </div>
        </div>
      </div>
    </StaticPageLayout>
  );
};

export default FaqPage;
